import { cva } from 'class-variance-authority';

export const cvaFreeParking = cva([
  'FreeParkingStyles-cvaFreeParking',
  'w-full z-30 overflow-hidden',
  'bg-cDarkGray rounded-t-[0.8rem]',
  'transition-all duration-300',
  'border-none',
]);

export const cvaFreeParkingInner = cva(
  ['FreeParkingStyles-cvaFreeParkingInner', 'relative', 'px-2.4 pb-2 pt-0.2'],
  {
    variants: {
      isScroll: {
        true: [
          // 'before:absolute before:bottom-[-2rem] before:left-0',
          // 'before:w-full before:h-2.4',
          // 'before:bg-gradient-to-b from-[#070417] to-transparent before:absolute before:opacity-[0.3]',
        ],
      },
    },
  }
);

export const cvaFreeParkingTitleBox = cva([
  'FreeParkingStyles-cvaFreeParkingTitleBox',
  'flex gap-1.2  justify-between',
  '[&_button]:h-fit',
]);

export const cvaFreeParkingTitle = cva([
  'FreeParkingStyles-cvaFreeParkingTitle',
  'text-header-s text-left text-cWhite',
  'mb-0.4',
]);
export const cvaFreeParkingAddress = cva(
  ['FreeParkingStyles-cvaFreeParkingText', 'text-m-sb text-left text-cGray'],
  {
    variants: {
      listText: {
        true: 'pl-2.4 pb-1.2',
      },
    },
  }
);

export const cvaFreeParkingSpaces = cva(
  [
    'FreeParkingStyles-cvaFreeParkingBadge',
    'text-m-sb text-cWhite',
    'py-0.7 px-1.2',
    'rounded-[8px]',
    'mt-1.2 h-3.4 w-fit',
  ],
  {
    variants: {
      active: {
        true: 'bg-cGreen',
        false: ['bg-cGray'],
      },
    },
  }
);

export const cvaFreeParkingButtons = cva([
  'FreeParkingStyles-cvaFreeParkingButtons',
  'py-1.6 px-2.4',
  'w-full',
  'grid grid-cols-2 gap-0.8',
]);

export const cvaFreeParkingButton = cva(
  [
    'FreeParkingStyles-cvaFreeParkingButton',
    'text-m-sb text-cWhite',
    'py-0.7 px-1.2',
    'w-full',
    'border-[3px] border-[#373541] rounded-[8px]',
  ],
  {
    variants: {
      active: {
        true: 'bg-[#373541]',
      },
    },
  }
);
